export default interface ErrorProp {
  hasError: boolean;
  message: string;
}

export const defaultErrorProp: ErrorProp = {
  hasError: false,
  message: ""
};
